// extracted by mini-css-extract-plugin
export default {"chatGptTop":"index_chatGptTop__-hThJ","ChatApp":"index_ChatApp__lSQCG","App":"index_App__WNeXd"};